module.exports = __webpack_public_path__ + "65961b585b671d864d0c517c4f2bb60d.pdf";